import { render } from "lit-html";
import { FormField } from "Components/form/zhi-form-field/zhi-form-field";

class ZhiCheckbox extends FormField {
  initialized = false;
  initialLabelContent = "";

  get label() {
    return this.initialLabelContent;
  }

  get submitValueType() {
    return "boolean";
  }

  get submitValue() {
    return this.inputElement?.checked ?? false;
  }

  get isValid() {
    if (this.isRequired === false) return true;
    return this.submitValue;
  }

  async initLabelContent() {
    await new Promise((resolve) => setTimeout(() => {
      this.initialLabelContent = this.innerHTML;
      this.innerHTML = "";
      this.initialized = true;
      resolve();
    }, 1000));
  }

  async initFormField() {
    await this.initLabelContent();
    await this.renderComponent();
    this.inputElement = this.querySelector('.zhi-checkbox__input');
    this.inputElement.checked = false;
    this.inputElement?.addEventListener('change', () => this.handleInputChanged());
    this.setAttribute("initialized", "");
  }

  async renderComponent() {
    if (this.initialized === false) return;
    const { checkboxTemplate } = await import("./zhi-checkbox.template");
    render(checkboxTemplate({ component: this }), this);
  }

  handleInputChanged() {
    this.toggleAttribute("checked", this.submitValue);
    super.handleInputChanged();
  }
}

customElements.define("zhi-checkbox", ZhiCheckbox);